export const Options = [
    { value: 'sara', label: 'Sara' },
    { value: 'pornografi', label: 'Pornografi' },
    { value: 'kekerasan', label: 'Kekerasan' },
    { value: 'lainnya', label: 'Lainya' }
]